import { useState, useEffect, useMemo } from 'react'
import { supabaseGetter } from '~/api/supabase-getter'

export const useTaskTypes = () => {
  const [taskTypes, setTaskTypes] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    async function fetchTaskTypes() {
      setLoading(true)
      setError(null)

      try {
        const { data, error: fetchError } = await supabaseGetter.taskTypes.getAll()
        if (fetchError) throw fetchError
        setTaskTypes(data || [])
      } catch (err) {
        console.error('Error fetching task types:', err)
        setError(err.message)
        setTaskTypes([])
      } finally {
        setLoading(false)
      }
    }

    fetchTaskTypes()
  }, [])

  const orgTaskTypes = useMemo(() => taskTypes.filter(t => t.target === 'plot'), [taskTypes])
  const cropTaskTypes = useMemo(() => taskTypes.filter(t => t.target === 'crop'), [taskTypes])

  return { taskTypes, orgTaskTypes, cropTaskTypes, loading, error }
}
